/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChiusuraVariazioneCapiUpdateDTO
 */
export interface ChiusuraVariazioneCapiUpdateDTO {
    /**
     * 
     * @type {number}
     * @memberof ChiusuraVariazioneCapiUpdateDTO
     */
    idTipoAnimale?: number;
    /**
     * 
     * @type {number}
     * @memberof ChiusuraVariazioneCapiUpdateDTO
     */
    capi?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ChiusuraVariazioneCapiUpdateDTO
     */
    peso?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ChiusuraVariazioneCapiUpdateDTO
     */
    note?: string | null;
}

/**
 * Check if a given object implements the ChiusuraVariazioneCapiUpdateDTO interface.
 */
export function instanceOfChiusuraVariazioneCapiUpdateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ChiusuraVariazioneCapiUpdateDTOFromJSON(json: any): ChiusuraVariazioneCapiUpdateDTO {
    return ChiusuraVariazioneCapiUpdateDTOFromJSONTyped(json, false);
}

export function ChiusuraVariazioneCapiUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChiusuraVariazioneCapiUpdateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idTipoAnimale': !exists(json, 'idTipoAnimale') ? undefined : json['idTipoAnimale'],
        'capi': !exists(json, 'capi') ? undefined : json['capi'],
        'peso': !exists(json, 'peso') ? undefined : json['peso'],
        'note': !exists(json, 'note') ? undefined : json['note'],
    };
}

export function ChiusuraVariazioneCapiUpdateDTOToJSON(value?: ChiusuraVariazioneCapiUpdateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idTipoAnimale': value.idTipoAnimale,
        'capi': value.capi,
        'peso': value.peso,
        'note': value.note,
    };
}

